import moment from "moment-timezone";

// Device payloads use Unix seconds, while APIs and ApexCharts also use milliseconds.
// Never let a missing value become "now" (Moment) or epoch zero (Number/Date).
export function toChartTimestamp(value) {
  if (value instanceof Date) {
    return Number.isFinite(value.getTime()) ? value.getTime() : null;
  }
  if (typeof value !== "number" && typeof value !== "string") return null;
  if (typeof value === "string" && !value.trim()) return null;
  const numeric = Number(value);
  if (Number.isFinite(numeric)) {
    const ms = Math.abs(numeric) < 1e11 ? numeric * 1000 : numeric;
    return Number.isFinite(new Date(ms).getTime()) ? Math.trunc(ms) : null;
  }
  if (typeof value !== "string") return null;
  const parsed = moment(value, moment.ISO_8601, true);
  return parsed.isValid() ? parsed.valueOf() : null;
}

export function eventChartTimestamp(event) {
  for (const value of [event?.device_timestamp, event?.createdAt, event?.raw?.time,
    event?.raw?.lastevent, event?.raw?.ts]) {
    const timestamp = toChartTimestamp(value);
    if (timestamp !== null) return timestamp;
  }
  return null;
}

export function formatCsvDateTime(timestamp) {
  const ms = toChartTimestamp(timestamp);
  return ms === null ? String(timestamp ?? "") : new Date(ms).toISOString();
}
